/**
 * Communications Interface
 * Stablish communications between this window and others.
 * This is just a listener. It doesn't send any message.
 */
import ee from '../../../UmiCore/src/EventDriver';

import ChatUtils from './components/utils/ChatUtils';

class ComIface {
  constructor() {
    this.setupListener();
  }

  setupListener() {
    window.addEventListener('message', (ev) => {
      const state = ev.data.landbotState;
      if (state)
        ee.emit('hu-load-config', state);
      
      const userMessage = ev.data.userMessage;
      if (userMessage)
        ChatUtils.sendMessage(userMessage, userMessage, [], [], false);
    });
  }
}

const comIface = new ComIface();
export default comIface;


// WEBPACK FOOTER //
// ./app/js/ComIface.js